import recipients from "@/store/app/entraId/settings/recipients"

export default {
  namespaced: true,

  actions: {},

  modules: {
    recipients,
  }
}
